export default __webpack_public_path__ + "static/media/Adore-Hair-and-Beauty.b5c9e205.png";